import { Component, OnInit } from '@angular/core';
import { PageOption } from '../../../models/common/pageOption';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { UserFilter } from '../../../models/users/userFilter';
import { User } from '../../../models/users/User';
import { TableColumn } from '../../../models/tables/TableColumn';
import { ParameterService } from '../../../services/parameter.service';
import { UserService } from '../../../services/user.service';
import { FormGroup, FormControl } from '@angular/forms';
import { UserColumns } from '../../../contants/columns/columns.user';
import { CommonService } from '../../../services/common.service';
import { Helper } from '../../../helpers/Helper';
import { PARAMS } from '../../../contants/PARAMS';
import { PaginatedList } from './../../../models/common/paginatedList';

@Component({
	selector: 'app-user-list',
	templateUrl: './user-list.component.html',
	styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
	pageOption: PageOption<UserFilter> = new PageOption();
	formPath: string = APP_ROUTES.userForm;
	viewPath: string = APP_ROUTES.userProfile;

	public paginatedUsers: PaginatedList<User> | undefined = undefined;
	public tableColumns: TableColumn[] = UserColumns;

	constructor(
		private _userService: UserService,
		private _parameterService: ParameterService,
		private _commonService: CommonService
	) { }

	ngOnInit() {
		this.pageOption.searchFilter = new UserFilter();
		this._parameterService.getCachedParameterObject<TableColumn[]>(PARAMS.USER_TABLE_DEFAULT_COLUMNS, 3600).subscribe(
			result => {
				if (result && result.length != undefined) {
					this.tableColumns = result.length == 0 ? this.tableColumns : result;
				}
				else {
					console.log('Invalid response from server, will use default column settings instead.')
				}
			});

		this._parameterService.getCachedParameter<number>(PARAMS.USER_TABLE_DEFAULT_PAGE_SIZE, 3600).subscribe(
			value => {
				value = Number(value);
				this.pageOption.pageSize = isNaN(value) || value == 0 ? 50 : value;
				this.pageOption.pageNumber = 1;

				this.fetchData();
			}
		);
	}

	fetchData(){
		this._userService.search(this.pageOption).subscribe(
			result => {
				this.paginatedUsers = result;
			}
		);
	}

	onFetchNextData(pageNumber: number){
		this.pageOption.pageNumber = pageNumber;
		this.fetchData();
	}

	search(filter: UserFilter) {
		if(filter != null){
			this.pageOption.searchFilter.name = Helper.isNullOrUndefined(filter.name) ? '' : filter.name;
			this.pageOption.searchFilter.email = Helper.isNullOrUndefined(filter.email) ? '' : filter.email;
			this.pageOption.searchFilter.employeeRole = Helper.isNullOrUndefined(filter.employeeRole) ? '' : filter.employeeRole;
			this.pageOption.searchFilter.isActive = filter.isActive;
		}

		this.fetchData();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/users/user-list/user-list.component.ts